import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useState, useEffect } from "react";
import "./App.css";
import Login from "./component/Login";
import Header from "./component/Header";
import ExamLanding from "./component/ExamLanding";
import Exam from "./component/Exam";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Check if user is logged in when the app loads
  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      console.log("User found in localStorage:", user); // Debugging log
      setIsAuthenticated(true);
    }
  }, []);

  console.log("App.js - isAuthenticated:", isAuthenticated); // Debugging log

  return (
    <BrowserRouter>
      {/* Header should always render */}
      <Header isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
      
      <Routes>
        <Route path="/" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
        <Route path="/landing" element={<ExamLanding />} />
        <Route path="/exam" element={<Exam />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
